import React from "react";
import Image from "@/bit/components/components.c-image";
import TextInfo from "@/bit/components/components.text";
import Price from "@/bit/components/components.price";
import Label from "@/bit/components/components.cms-block.cms-label";
import DetailCardTitle from "@/bit/components/components.cms-block.cms-detail-card-title";

function truncateText(text, maxLength = 50) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text; // Si es menor o igual a maxLength, devolvemos la cadena original.
}

const checkIfEmpty = (element) => {
  let res = true;
  if (element?.text || element?.price) {
    res = false;
  }

  return res;
};

const CardContent = ({ detailCardProps, cmsHandler }) => {
  const {
    imageSize,
    layout = "default",
    shadow,
    "cms-atom-label-1": detailCardLabel1,
    "cms-atom-price-1": detailCardPrice1,
    "cms-atom-price-2": detailCardPrice2,
    "cms-atom-image-1": detailCardImage1,
    "cms-atom-text-2": detailCardText2,
    "cms-atom-text-3": detailCardText3,
    "cms-atom-text-4": detailCardText4,
    "cms-ml-detail-card-title-1": detailCardTitle,
  } = detailCardProps;

  // Que haya un minimo de contenido de price
  const isPriceContentEmpty =
    [
      detailCardPrice1,
      detailCardPrice2,
      detailCardText3,
      detailCardText4,
    ].every(checkIfEmpty) && !cmsHandler;

  if (layout === "small" && detailCardText2?.text) {
    detailCardText2.text = truncateText(detailCardText2.text);
  }

  return (
    <>
      {/* Velo imagenes */}
      {shadow && shadow !== "none" && (
        <div
          className={`card-shadow${shadow === "gradient" ? "-gradient" : ""}`}
        ></div>
      )}
      {detailCardImage1 && (detailCardImage1.src || cmsHandler) && (
        <div
          className={`image-gap${imageSize ? " size-" + imageSize : ""}`}
          aria-hidden="true"
        >
          <Image
            objectFit="cover"
            {...detailCardImage1}
            cmsHandler={cmsHandler}
          />
        </div>
      )}
      <div
        className={`content${
          cmsHandler && imageSize && imageSize === "full"
            ? " content-resize"
            : ""
        }`}
      >
        {detailCardTitle && (
          <DetailCardTitle
            detailCardTitleProps={detailCardTitle}
            cmsHandler={cmsHandler}
          />
        )}
        <TextInfo
          {...detailCardText2}
          className="description-gap"
          cmsHandler={cmsHandler}
        />
        <div className="card-price-content">
          {!isPriceContentEmpty && (
            <div className="price-content">
              <Label {...detailCardLabel1} cmsHandler={cmsHandler} />
              <TextInfo
                {...detailCardText3}
                className="pre-price"
                cmsHandler={cmsHandler}
              />
              <div className="price-inline">
                <Price {...detailCardPrice2} cmsHandler={cmsHandler} />
                <Price {...detailCardPrice1} cmsHandler={cmsHandler} />
              </div>
              <TextInfo
                {...detailCardText4}
                className="post-price"
                cmsHandler={cmsHandler}
              />
            </div>
          )}
        </div>
      </div>
      <style jsx>{`:global(.block-link) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-price-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
  position: relative;

  .price-inline {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
}

.content {
  padding: 1rem;
  padding-bottom: 0;

  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  flex: 1;
  // z-index: 2;
  &.content-resize {
    margin-top: 40px;
  }
  .content-price {
    display: flex;
    gap: 0.5rem;
  }
}
.image-gap {
  position: relative;
  min-height: 14.9rem;
  aspect-ratio: 4 / 3;
  width: 100%;
  &.size-small {
    min-height: 6rem;
    aspect-ratio: 13 / 3;
  }
  &.size-16_9 {
    min-height: 11rem;
    aspect-ratio: 16 / 9;
  }
  &.size-full {
    min-height: 100%;
    position: absolute;
  }
}

.card-shadow-gradient {
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0.5) 33%,
    rgba(0, 0, 0, 0) 44%,
    rgba(0, 0, 0, 0) 100%
  );
}
.card-shadow {
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.7);
}
`}</style>
    </>
  );
};

export default CardContent;
